/* eslint-disable camelcase */
export const DEFAULT_AD_NETWORK_URL =
  "https://pubads.g.doubleclick.net/gampad/ads";
export const DEFAULT_AD_NETWORK_QUERY_STRING_PARAMETERS = {
  description_url: "Verse",
  env: "vp",
  gdfp_req: 1,
  impl: "s",
  iu: "/141732119/sam-ios",
  output: "vast",
  sz: "640x360",
  unviewed_position_start: 1,
};
